import React, { useState, useEffect } from 'react'
import API from '../../utils/API'
import { Container, Row, Col } from 'react-bootstrap'
import parse from 'html-react-parser'
import PageCreator from '../../components/PageCreator'
import EventCalImage from '../../assets/images/events_cal.jpg'
import moment from 'moment'

// import { response } from 'express';

export default function EventDetails({ match }) {
    const [eventDetail, setEventDetail] = useState({})

    useEffect(() => {
        //   getNewsInfo()
        const fetchEvents = () =>{
        try {
            API.getEventDetails(match.params.id).then(
                function (response) {
                    setEventDetail(response.data)
                    // console.log(response.data)
                })
        }
        catch (error) {
            throw error
        }
    };
    fetchEvents();
    }, []);


    return (
        <div>
            <PageCreator imageName={EventCalImage} opacityLevel='0.75'>
                <Container>
                    <Row>
                        <Col>
                            <p style={{ color: "#000000", fontSize: '2em', textAlign: 'center' }} className="mainFont">{eventDetail.eventTitle}</p>
                            <hr />
                            <p style={{ color: "#000000", fontSize: '1em', textAlign: 'left' }} className="mainFont">Date of Event: {eventDetail.eventDate}</p>
                            <p style={{ color: "#000000", fontSize: '1em', textAlign: 'left' }} className="mainFont">Time of Event: {moment(eventDetail.eventTime, 'HH:mm:ss').format('hh:mm a')}</p>
                            <p style={{ color: "#000000", fontSize: '1em', textAlign: 'left' }} className="mainFont">Event Description</p>

                            {parse(String(eventDetail.eventDescription))}
                        </Col>
                    </Row>
                </Container>
            </PageCreator>

        </div>
    )
}
